import { Star } from 'lucide-react-native';
import { twJoin } from 'tailwind-merge';

import { HStack } from '@/components/ui/hstack';
import { Icon } from '@/components/ui/icon';
import { Text } from '@/components/ui/text';

type FeaturedBadgeProps = {
  className?: string;
  label?: string;
  showIcon?: boolean;
};

/**
 * Badge component displaying an optional star icon and customizable label text.
 *
 * Design tokens:
 * - highlight-50: Light cream background
 * - highlight-800: Dark brownish-red text (WCAG AA contrast compliant)
 */
export function FeaturedBadge({
  className,
  label = 'Featured',
  showIcon = true,
}: FeaturedBadgeProps) {
  return (
    <HStack
      className={twJoin('items-center gap-1.5 rounded-sm bg-highlight-50 px-2 py-0.5', className)}>
      {showIcon ? <Icon as={Star} size="xs" className="text-highlight-800" /> : null}
      <Text className="font-medium text-xs uppercase text-highlight-800" numberOfLines={1}>
        {label}
      </Text>
    </HStack>
  );
}
